// Next runs this before the client module graph and hydration, so Sentry is
// initialized ahead of the providers and router (which run work at module scope).
import { initSentry } from "@/lib/sentry"

initSentry()
